































































































































































import { Component } from "vue-property-decorator";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { i18n } from "@/resources/locales";
import { Validate } from "vuelidate-property-decorators";
import { url, email, required } from "vuelidate/lib/validators";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { LANGUAGES } from "../../../../resources/constants/userLanguages";
@Component({
  name: "profile-social-component",
})
export default class SocialComponent extends mixins(UserValidator) {
  LANGUAGES = LANGUAGES;
  occupation = "";
  myMotto = "";
  biography = "";
  @Validate({ url })
  linkedin = "";
  @Validate({ url })
  twitter = "";
  @Validate({ url })
  playlist = "";
  @Validate({ email })
  socialEmail = "";
  loading = false;
  languages = [];
  user: UserInterface;
  constructor() {
    super();
    this.user = this.$store.getters["UserStore/getUser"];
    this.occupation = this.user.occupation;
    this.myMotto = this.user.myMotto;
    this.biography = this.user.biography;
    this.linkedin = this.user.linkedin;
    this.twitter = this.user.twitter;
    this.playlist = this.user.playlist != null ? "https://open.spotify.com/playlist/" + this.user.playlist:"" ;
    this.socialEmail = this.user.socialEmail;
    this.languages = this.user.languages || [];
  }
  onBoarding() {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  updateUserData(): void {
    this.loading = true;
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.user.id,
      props: {
        occupation: this.occupation,
        myMotto: this.myMotto,
        biography: this.biography,
        linkedin: this.linkedin,
        twitter: this.twitter,
        playlist: this.playlist,
        socialEmail: this.socialEmail,
        languages: this.languages,
      },
      callback: (user) => {
        this.loading = false;

        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
        this.$vs.notification({
          color: "success",
          title: i18n.t("notifications.titles.success"),
          text: i18n.t("notifications.descriptions.userUpdate"),
        });
      },
    });
  }
}
